module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/5-unawareness.json
// module id = 337
// module chunks = 127993006669303